/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvaHRtbC9NeURlc2lnblYzL2h0bWwvc3JjL2FwcC9hZG1pbi9zdWJncm91cHMvc3ViZ3JvdXBzLWRhc2hib2FyZC9zdWJncm91cHMtZGFzaGJvYXJkLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL3d3dy9odG1sL015RGVzaWduVjMvaHRtbC9zcmMvYXBwL2FkbWluL3N1Ymdyb3Vwcy9zdWJncm91cHMtZGFzaGJvYXJkL3N1Ymdyb3Vwcy1kYXNoYm9hcmQuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/admin/subgroups/subgroups-dashboard/subgroups-dashboard.component.css.shim.ngstyle.ts